<template>
	<div>
		<v-overlay v-model="loading" absolute>
			<v-progress-circular indeterminate size="32"></v-progress-circular>
		</v-overlay>
		<h6 v-if="!loading" class="text-h6 white--text pl-1 mb-2">Project Properties</h6>
		<v-simple-table v-if="!loading">
			<template #default>
				<thead>
					<tr>
						<th class="text-left">
							Asset Address
						</th>
						<th class="text-left">
							Property Type
						</th>
						<th class="text-left">
							Asset Relationship
						</th>
						<th class="text-left">
							Laborer
						</th>
						<th class="text-center">
							Status
						</th>
						<th></th>
					</tr>
				</thead>
				<tbody>
					<template v-if="length(properties) >= 1">
						<tr
							v-for="property in properties"
							:key="property.id">
							<td>{{ property.full_address }}</td>
							<td>{{ property.type }}</td>
							<td>{{ property.asset_relationship }}</td>
							<td>
								<v-edit-dialog
									v-if="auth.user_type === 1"
									persistent
									large
									:return-value.sync="property.laborer[0]"
									@save="updateLabor(property)">
									<span v-if="!property.laborer[0]" class="grey--text">
										Not Assigned
									</span>
									<span v-else>
										{{ property.laborer[0].first_name }} {{ property.laborer[0].last_name }}
									</span>
									<template #input>
										<v-autocomplete
											v-model="property.laborer[0]"
											:items="laborers"
											item-text="name"
											return-object
											hide-details
											placeholder="Select Laborer"
											single-line />
									</template>
								</v-edit-dialog>
								<span v-else>
									{{ property.laborer[0].first_name }} {{ property.laborer[0].last_name }}
								</span>
							</td>
							<td :class="property.status.color" class="status text-center">
								<v-edit-dialog
									persistent
									large
									:return-value.sync="property.status"
									@save="updateStatus(property)">
									<span class="status text--darken-4" :class="property.status.color.split(' ')[0] + '--text'">{{ property.status.name }}</span>
									<template #input>
										<v-autocomplete
											v-model="property.status"
											:items="statuses"
											item-text="name"
											return-object
											hide-details
											placeholder="Select Status"
											single-line />
									</template>
								</v-edit-dialog>
							</td>
							<td class="actions-dots text-end pr-2">
								<v-menu bottom
									left
									allow-overflow
									min-width="235">
									<template #activator="{ on, attrs }">
										<v-btn
											icon
											color="#444"
											v-bind="attrs"
											v-on="on">
											<v-icon>mdi-dots-vertical</v-icon>
										</v-btn>
									</template>

									<v-list dense>
										<v-list-item dense link href="#">
											<v-dialog transition="scroll-x-reverse-transition" max-width="1100">
												<template #activator="{ on, attrs }">
													<v-list-item-icon>
														<v-icon color="secondary">
															mdi-pencil
														</v-icon>
													</v-list-item-icon>
													<v-list-item-content>
														<v-list-item-title
															model="property[0]"
															:model-id="property.id"
															v-bind="attrs"
															v-on="on">
															Edit Property
														</v-list-item-title>
													</v-list-item-content>
												</template>
												<template #default="dialogEdit">
													<v-card>
														<v-card-title>
															<div>Edit Property</div>
															<v-icon right class="ml-auto theme--dark" @click="dialogEdit.value = false">mdi-close</v-icon>
														</v-card-title>
														<v-divider class="mb-5" />
														<v-card-text>
															<property-form :property="property"></property-form>
														</v-card-text>
													</v-card>
												</template>
											</v-dialog>
										</v-list-item>
										<Link :href="route('properties.data', property)" class="v-list-item v-list-item--dense v-list-item--link theme--light">
											<div class="v-list-item__icon"><v-icon color="primary">mdi-file-document-edit</v-icon></div>
											<div class="v-list-item__content"><div class="v-list-item__title">Report Writer Data</div></div>
										</Link>
									</v-list>
								</v-menu>
							</td>
						</tr>
					</template>
					<tr v-else>
						<td colspan="42" class="text-center">
							--
						</td>
					</tr>
				</tbody>
			</template>
		</v-simple-table>

		<SendLaborAssignment v-model="laborAssignmentDialog"
			:project="project"
			:property="assignedProperty"
			:laborer="laborAssignmentModel" />
	</div>
</template>
<script>
import PropertyForm from '@/Pages/Backend/Properties/Form'
import api from '@/api'
import SendLaborAssignment from '@/Pages/Backend/Components/Dialogs/SendLaborAssignment.vue'

export default {
	components: { SendLaborAssignment, PropertyForm },
	props: {
		project: {
			type: Object,
			required: true
		}
	},
	data () {
		return {
			loading: true,
			properties: [],
			laborers: [],
			laborAssignmentDialog: false,
			laborAssignmentModel: {},
			assignedProperty: {},
			sendingAssignment: false,
			laborAssignment: this.$inertia.form({
				subject: 'Bell Oldow Environmental Job Assignment - Please Respond ASAP',
				message: ''
			}),
			auth: this.$page.props.auth,
			statuses: []
		}
	},
	mounted () {
		this.getProperties()
		this.getLaborers()
		this.getPropertyStatuses()
	},
	methods: {
		getProperties () {
			const method = 'GET'
			const data = {}

			const url = this.route('projects.api.properties', this.project)

			return api({
				method,
				url,
				data
			}).then(response => {
				this.properties = response.data
				this.loading = false
			})
		},
		getLaborers () {
			const method = 'GET'
			const data = {}

			const url = this.route('users.api.laborers')

			return api({
				method,
				url,
				data
			}).then(response => {
				this.laborers = response.data
			})
		},
		getPropertyStatuses () {
			const method = 'GET'
			const data = {}

			const url = this.route('property-statuses.api.index')

			return api({
				method,
				url,
				data
			}).then(response => {
				this.statuses = response.data
			})
		},
		updateStatus (property) {
			this.loading = true
			property.property_status_id = property.status.id

			const route = this.route('properties.update', { project: property.project_id, property: property.id })

			this.$inertia.put(route, property, {
				only: ['properties', 'flash'],
				preserveScroll: true,
				preserveState: true,
				onFinish: () => this.loading = false
			})
		},
		updateLabor (property) {
			this.loading = true

			const route = this.route('properties.update.labor', { property: property.id })

			this.$inertia.put(route, property, {
				only: ['flash'],
				preserveScroll: true,
				preserveState: true,
				onFinish: () => this.loading = false
			})

			if (property.hasOwnProperty('laborer') && this.length(property.laborer)) {
				this.laborAssignmentDialog = true
				this.laborAssignmentModel = property.laborer[0]
				this.assignedProperty = property
			}
		}
	}
}
</script>
